module.exports = __webpack_public_path__ + "img/unsub-logo-white.6e2286bf.png";